export const getCurrentDevice = () => {
	let theDevice = 'Desktop';
	const theWidth = window.innerWidth;
	const theHeight = window.innerHeight;
	if (
		( theWidth &&
			theWidth <= 1200 &&
			theWidth > 900 &&
			theWidth >= theHeight ) ||
		( theWidth &&
			theWidth <= 900 &&
			theWidth > 600 &&
			theWidth < theHeight )
	) {
		theDevice = 'Tablet';
	} else if (
		( theWidth && theWidth <= 900 && theWidth >= theHeight ) ||
		( theWidth && theWidth <= 600 )
	) {
		theDevice = 'Mobile';
	}
	return theDevice;
};
